export class OrganizationProvince {
  public id: string;
  public name: string;

  constructor(data: Partial<OrganizationProvince> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: any = {}): OrganizationProvince {
    return new OrganizationProvince({
      id: data?.id ?? '',
      name: data?.name ?? data?.title ?? '',
    });
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      name: this.name,
    };
  }
}
